import get from 'lodash/get';
import { getSelectedPeople } from '../people/selectors';
import { getSelectedProgram } from '../program/selectors';

export const getAwardValue = state => get( state, 'award.awardValue', undefined );
export const getAllocatePoints = state => get( state, 'award.allocatePoints', false );
export const getTotalAward = state => {
    const selectedPeople = getSelectedPeople( state );
    let totalAward = 0;
    for ( let i = 0; i < selectedPeople.length; i++ ) 
    {
        totalAward = totalAward + selectedPeople[ i ].awardValue || 0;
    }
    return totalAward;
};
export const getRemainingBudget = state => {
    const budget = get( getSelectedProgram( state ), 'budgets[0]', {} );
    const totalAward = getTotalAward( state );
    const { convertedCurrentValue } = budget;
    let remainingBudget = 0;
    if ( convertedCurrentValue )
    {
        remainingBudget = convertedCurrentValue - totalAward;
    }
    return remainingBudget;
};
export const getRemainingBudgetPercent = state => {
    const budget = get( getSelectedProgram( state ), 'budgets[0]', {} );
    const { convertedInitialValue } = budget;
    const remainingBudget = getRemainingBudget( state );
    let percent = 0;
    if ( remainingBudget && convertedInitialValue )
    {
        percent = ( parseInt( remainingBudget ) / parseInt( convertedInitialValue ) * 100 );
    }
    return percent;
};